import type { BusinessPageLocations } from '@/types/ga4/tracking-locations'

export const BUSINESS_HERO_LOCATION = 'business_hero'
export const BUSINESS_CONTACT_FORM_LOCATION = 'business_contact_form'

export const GET_STARTED_BUTTON_ID = 'get_started_button'

export const BUSINESS_PAGE_LOCATIONS = {
	hero: BUSINESS_HERO_LOCATION,
	contactForm: BUSINESS_CONTACT_FORM_LOCATION
} as const satisfies BusinessPageLocations
